import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const input = ({
  palette,
}: InternalThemeConfig): ComponentsOverrides<Theme>["MuiInput"] => ({
  root: {
    color: palette.black,
  },
  underline: {
    "&:hover:not(.Mui-disabled):before": {
      borderBottomColor: palette.primary,
    },
    "&:before": {
      borderBottomColor: palette.grey40,
      borderBottomStyle: "solid !important",
    },
  },
});

export default input;
